export * from './chart.directive';
export * from './color.service';
export * from './colors.service';
export * from './chart.module';



// WEBPACK FOOTER //
// ./node_modules/angular-bootstrap-md/charts/index.ts